import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import { Table, Form, Segment, Button, Divider, Image } from 'semantic-ui-react';
import Select from 'react-select';
import FileUploader from 'react-firebase-file-uploader';
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import axios from 'axios'
import { serverIp, toCurrency, firebaseAuth, firebaseStorage, logComponentLoad } from '../../../../config/constants.js'
import { getShirtTypesToDisplay, getExpenseAccounts } from '../LargeProjects/ApiUtils'
import ViewRequisition_dynamic from '../Requisition/ViewRequisition_dynamic.js';
//import { getShirtTypeDownDown } from '../dashBoard/newDashboard/LargeProjects/ApiUtils'
import Iframe from 'react-iframe'

import * as UiConsts from '../../../../config/UiConstants';

class DeductExpenseAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // stockItemOptions: [],
            shirtTypeOptions: [],
            expenseAccount: '',
            amount: '',
            notes: '',
            loading: false,
            dateNum: '',
            // requisition
            reqSelected: false,
            req: {},
            reqConfirmed: false,
            reqSelected: false,
            dropdownItems: [],
            shirtTypeId: '',
            docUrl: ''
        }
    }


    componentDidMount() {
        console.log("expAc3 +++++++:componentDidMount PaySingleStockItem");

        //getExpenseAccounts(this.setExpenseAccounts);
        getShirtTypesToDisplay(this.setShirtTypeDropDown, "expenseAcc_deduct");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })


    }


    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        //console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "DeductExpenseAccount");
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    setShirtTypeDropDown = (shirtTypes) => {
        console.log("expAc32 +++++++:setShirtTypeDropDown");
        console.log("expAc33:" + JSON.stringify(shirtTypes, null, 3));
        this.setState({
            shirtTypeOptions: shirtTypes
        })

        // GET REQUISITIONS SUBMITTED BY SOLO
        this.getReqsSubmittedBy();
    }

    // setExpenseAccounts = (expenseAccounts) => {
    //     console.log("expAc31 +++++++:setExpenseAccounts");
    //     console.log("expAc32:" + JSON.stringify(expenseAccounts, null, 3));
    //     this.setState({
    //         expenseAccountOptions: expenseAccounts
    //     })

    // }


    handleDropDownChanges = (value) => {
        console.log("docx19 handleDropDownChanges");
        console.log('docx191 You\'ve sss:', value);
        console.log("docx192 category alone:" + value.category);
        console.log('docx193 You\'ve selected:', value.value + " " + value.category);
        console.log("docx195 - array index:" + this.props.arrayIndex);
        console.log('docx199 amount:', value.rate);

        let newState = {};
        newState[value.category] = value.value;
        console.log("expAc33 1:" + JSON.stringify(newState, null, 3));

        if (value.category == 'unpaid_req') {
            console.log("value.category == 'unpaid_req'");
            newState['amount'] = value.rate;
            newState['notes'] = value.label;
        }

        //this.setState(newState);
        this.setState(newState);
    }



    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("expAc33 e.target.name:" + e.target.name);
        console.log("expAc33 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }

    handleUploadStart = (file) => {
        console.log("docx14 ++++++ handle uploadStart file:" + file.name.split('.')[0]);

        this.setState({ isUploading: true, progress: 0, actualFileName: file.name });
    }

    // handleUploadSuccess = (fileName) => this.setState({fileName:fileName, isUploading: false, progress: 100});
    handleUploadSuccess = (saveFileName) => {
        console.log("docx15 +++++++handleUploadSuccess");

        this.setState({ fileName: saveFileName, isUploading: false, progress: 100 });

        //UDPATE URL 
        // let orderKey = this.props.fileName;
        firebaseStorage.ref('printbdocs').child(saveFileName).getDownloadURL().then(
            url => {
                this.setState({ docUrl: url })
                console.log("docx16 docUrl is:" + url);

                // let tempRef = db.ref('orders').child(orderKey);
                // //UDPATE FIREBASE OBJECT WITH OBJECT NAME..
                // tempRef.update('fileUrl':url);

                // let updates = {};
                // updates['/orders/' + orderKey + '/fileUrl'] = url;
                // updates['/orders/' + orderKey + '/fileName'] = saveFileName;
                // updates['/orders/' + orderKey + '/usersFileName'] = this.state.actualFileName;
                // ref.update(updates);
                this.updateWhenFileUploadComplete(true, this.state.actualFileName, url);
            }
        );
    };

    handleProgress = (progress) => this.setState({ progress });
    handleUploadError = (error) => {
        console.log("docx16 +++++++: handleUploadError");

        this.setState({ isUploading: false });
        console.error(error);
    }

    updateWhenFileUploadComplete = (uploaded, fileName, url) => {
        console.log("docx17 +++++++: updateWhenFileUploadComplete");
        console.log("docx181 uploaded:" + uploaded);
        console.log("docx18 fileName:" + fileName);
        console.log("docx19 url:" + url)
    }


    deductExpenseAccEndPoint = () => {
        console.log("expAc34 ++++++++:sendList");
        console.log("expAc35 shirtTypeId:" + this.state.shirtTypeId);
        console.log("expAc36 amount:" + this.state.amount);
        console.log("expAc362 notes:" + this.state.notes);


        if (this.state.amount == '') {
            alert("pls enter amount");

        } else if (this.state.notes == '') {
            alert("pls enter notes");

        } else if (this.state.dateNum == '') {
            alert("pls enter date");

        } else if (this.state.shirtTypeId == '') {
            alert("pls select item");

        } else if (this.state.docUrl == '') {
            alert("pls upload receipt");
        } else {

            this.setState({ loading: true });

            // axios.post(pythonApiIp + 'deductExpenseAccEndPoint', {
            //     apiKey: "ad#4fsdUUddf",
            //     shirtTypeId: this.state.shirtTypeId,
            //     amount: parseInt(this.state.amount),
            //     notes: this.state.notes,
            //     enteredBy: this.props.user.email,
            //     dateSpent: this.state.dateNum,
            //     imageUrl: this.state.docUrl
            // })

            axios.post(serverIp + 'expenseAccounts/updateExpenseAccount', {
                apiKey: "ad#4fsdUUddf",
                action: "subtract",
                shirtTypeId: this.state.shirtTypeId,
                amountSent: parseInt(this.state.amount),
                notes: this.state.notes,
                enteredBy: this.state.user.email,
                dateSent: this.state.dateNum,
                imageUrl: this.state.docUrl,
                reqId: this.state.unpaid_req
            })
                .then((response) => {
                    console.log("expAc39 response:" + JSON.stringify(response.data));
                    this.setState({ loading: false });
                    console.log("expAc391 result:" + response.data.result);

                    if (response.data.result) {

                        alert(response.data.message);
                        this.setState({
                            expenseAccount: null,
                            qty: '',
                            amount: '',
                            notes: '',
                            docUrl: null
                        })

                    } else {

                        this.setState({ loading: false });

                        alert(response.data.message);

                    }
                    //this.resetFields();
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                });
        }



    }

    getReqsSubmittedBy = () => {
        console.log("entx1 +++++ getUnPaidReqs - ");
        axios.post(serverIp + 'billing/getReqsSubmittedBy', {
            apiKey: this.state.user.uid,
            enteredBy: this.state.user.email,
            addedBy: "proposals@printboda.com"
        })
            .then((response) => {
                console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                console.log("entx22 result:" + response.data.result);

                
                // CHECK RECEIPTS
                if (response.data.result && response.data.dropdownItems) {

                    this.setState({
                        loading: false,
                        dropdownItems: response.data.dropdownItems
                    });
                    // alert("password retrieved:"); 

                    // CHECK ORDER NUMBER
                } else if (!response.data.result) {
                    alert("Error:" + response.data.message);
                    this.setState({ loading: false });
                }

                this.clearFields();

            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })
                this.clearFields();
            });
    }

    clearFields = () => {

        this.setState({
            loading: false,
            amountNeeded: 0,
            reason: '',
            reasonSelected: false,
            reqSelected: false,
            openPbAccountReason: null,
            docUrl: '',
            recUploaded: false,
            pb_account_pass: ''
        })
    }

    render() {

        const sendButtonUI = <Button color='green'> ENTER IMPORT EXPENSE</Button>


        const userUploadedImage = this.state.docUrl
            ? (<Image src={this.state.docUrl} size='medium' centered bordered shape='rounded' />)
            : (<p></p>)

        const fileUploadUI = <div>
            <h4>UPLOAD RECEIPT: {this.state.docUrl}</h4>
            <FileUploader
                accept="*,"
                name="avatar"
                filename={this.props.fileName}
                //storageRef={firebaseStorage.ref('orderDesigns/')}
                storageRef={firebaseStorage.ref('printbdocs')}
                onUploadStart={this.handleUploadStart}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
            />
            {userUploadedImage}
        </div>

        const reqs = this.state.dropdownItems.length > 0
            ? <div>
                <Divider horizontal>{'Select Requisition - REQUISTION HAS TO BE ENTERED BY SOLOMON'}</Divider>
                <Select
                    name="form-field-name"
                    value={this.state.unpaid_req}
                    options={this.state.dropdownItems}
                    onChange={this.handleDropDownChanges}
                    searchable={true}
                    clearable={false}
                />
            </div>
            : ''

        const wholeUI = this.state.algoliaUser
            && this.state.algoliaUser != ''
            && this.state.algoliaUser.perms
            && this.state.algoliaUser.perms.includes("DailyExpenses_ivan")
            ? <div>
                <h1>DEDUCT IMPORT COST</h1>
                <Divider horizontal>{'DEDUCT EXPENSE ACCOUNT'}</Divider>

                {/* REQUISTIONS */}
                {reqs}

                <Segment>
                    <Form fixed onSubmit={this.deductExpenseAccEndPoint}>

                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            isOutsideRange={() => false}
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                        />
                        <h2>{this.state.dateString}</h2>

                        <label>Select Item </label>
                        <Select
                            name="form-field-name"
                            value={this.state.shirtTypeId}
                            options={this.state.shirtTypeOptions}
                            onChange={this.handleDropDownChanges}
                            searchable={true}
                            clearable={false}
                        />


                        {/* amount */}
                        <Form.Field>
                            <label>amount: {toCurrency(this.state.amount)} </label>
                            <Form.Input
                                fluid
                                name={'amount'}
                                value={this.state.amount}
                                icon='dollar'
                                iconPosition='left'
                                placeholder='amount'
                                onChange={this.handleTextInputChange}
                                type='number'
                            />
                        </Form.Field>

                        {/* notes */}
                        <Form.Field>
                            <label>Notes: {this.state.notes} </label>
                            <Form.Input
                                fluid
                                name={'notes'}
                                value={this.state.notes}
                                icon='dollar'
                                iconPosition='left'
                                placeholder='notes'
                                onChange={this.handleTextInputChange}
                                type='text'
                            />
                        </Form.Field>

                        {fileUploadUI}

                        {sendButtonUI}


                    </Form>
                </Segment>

                <h2>IMPORT LIST</h2>
                <Iframe url="https://datastudio.google.com/embed/reporting/a4d8f4b9-933e-4cae-bdd1-05b0ded0e3c0/page/scndC"
                    width="100%"
                    height="450px"
                    id="myId"
                    className="myClassname"
                    display="initial"
                    position="relative" />

      </div>
            : "ERROR AUTH"

        // : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (this.state.loading ? <UiConsts.LoadingComponent /> :
            <div>

                {wholeUI}

            </div>);
    }
}

export default DeductExpenseAccount;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ExpenseAccounts/DeductExpenseAccount.js